var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6742 0.568756L25.5992 11.4438L24.268 12.775L22.3742 11.0575V23.2938L21.4367 24.2313H15.8117L14.8742 23.2938V16.7313H11.1242V23.2938L10.1867 24.2313H4.56172L3.62422 23.2938V11.0725L1.74922 12.775L0.417969 11.4438L12.3242 0.568756H13.6742ZM5.49922 9.36813V22.3563H9.24922V15.7938L10.1867 14.8563H15.8117L16.7492 15.7938V22.3563H20.4992V9.35688L12.9992 2.55626L5.49922 9.36813Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.a9ca69cd4cb2c0c6c07d632f9e41f0db.svg";
export { ForwardRef as ReactComponent };